import { IconButton, SxProps, Tooltip } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

interface CopyButtonProperties {
  text: string;
  tooltip?: string;
  size?: 'small' | 'medium' | 'large';
  iconFontSize?: string;
  sx?: SxProps;
}

export const CopyButton = ({
  text,
  tooltip = 'Copy',
  size = 'small',
  iconFontSize = '0.875rem',
  sx,
}: CopyButtonProperties) => (
  <Tooltip title={tooltip}>
    <IconButton size={size} onClick={() => void navigator.clipboard.writeText(text)} sx={sx}>
      <ContentCopy sx={{ fontSize: iconFontSize }} />
    </IconButton>
  </Tooltip>
);
